import { render, staticRenderFns } from "./BlwSelect.vue?vue&type=template&id=058f0730&"
import script from "./BlwSelect.vue?vue&type=script&lang=js&"
export * from "./BlwSelect.vue?vue&type=script&lang=js&"
import style0 from "./BlwSelect.vue?vue&type=style&index=0&id=058f0730&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports